export default "__VITE_ASSET__CNPpnNIB__"